import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=4c54d38a&scoped=true&"
import script from "./certificate.vue?vue&type=script&lang=js&"
export * from "./certificate.vue?vue&type=script&lang=js&"
import style0 from "./certificate.vue?vue&type=style&index=0&id=4c54d38a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54d38a",
  null
  
)

export default component.exports